import {
  apiURL
} from '../../config/app';
const querystring = require('querystring')

const getPayments = async ({ authToken, from, to, page, limit = 20, lastEvaluatedKey }) => {
  let query;
  if (lastEvaluatedKey) {
    query = querystring.stringify(lastEvaluatedKey)
  }
  const response = await fetch(`${apiURL}/payments?from=${from}&to=${to}&limit=${limit}&page=${page}${lastEvaluatedKey ? `&${query}` : ''}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const deletePayment = async ({ authToken, paymentId, historyId }) => {
  const response = await fetch(`${apiURL}/history/${historyId}/payments/${paymentId}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const deleteHistory = async ({ authToken, historyId }) => {
  const response = await fetch(`${apiURL}/history/${historyId}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

export default {
  getPayments,
  deletePayment,
  deleteHistory
};



// WEBPACK FOOTER //
// ./api/payments.js